import React, { ChangeEvent } from "react";
import "./index.scss";

interface IProps {
	defaultValue: number;
	value: number;
	min: number;
	max: number;
	prop: string;
	onChange: (e: ChangeEvent) => void;
}

export default class GenericSlider extends React.Component<IProps> {
	render() {
		const {
			defaultValue,
			value,
			min,
			max,
			prop,
			onChange
		} = this.props;

		const leftWidth = (value - min) / max * 100;

		return (
			<div className="slidecontainer">
				<input type="range"
					min={min}
					max={max}
					value={value}
					className="slider"

					{...{ prop: prop }}
					onChange={onChange}
				/>

				<div
					className="slider-left"
					style={{ width: `${leftWidth}%` }}
				/>
			</div>
		);
	}
}